import React from 'react';

import { CmInput } from '@/components/uiParts';
import {
  INPUT_GROUP_NAME_ID,
  MAX_GROUP_NAME_LENGTH,
} from '@/pages/link-items/LinkItemsPage';

interface Props {
  groupIndex: number;
  value?: string;
  handleGroupName: (groupName: string, index: number) => void;
}
export const GroupNameInput: React.FC<Props> = ({
  groupIndex,
  value,
  handleGroupName,
}) => {
  return (
    <CmInput
      id={`${INPUT_GROUP_NAME_ID + groupIndex}`}
      onClick={(e) => e.stopPropagation()}
      borderColor="gray"
      bg="white"
      _hover={{ borderColor: 'gray' }}
      isRequired
      {...{ value }}
      onChange={(e) => handleGroupName(e.target.value, groupIndex)}
      placeholder={`必須${' '}・${' '}${MAX_GROUP_NAME_LENGTH}文字以内`}
    />
  );
};
